module.exports = __webpack_public_path__ + "img/1_031.30e28d21.jpg";